// Real scraper data from the provided dataset with simplified payer names
export const realUrlCounts = [
  { id: 1, name: '001 Aetna', urlCount: 896 },
  { id: 39, name: '039 AlohaCare', urlCount: 18 },
  { id: 27, name: '027 AmeriHealth New Jersey', urlCount: 699 },
  { id: 4, name: '004 BCBS Arkansas', urlCount: 890 },
  { id: 40, name: '040 AvMed', urlCount: 124 },
  { id: 52, name: '052 BCBS Wellmark', urlCount: 200 },
  { id: 41, name: '041 Baylor Scott & White Health Plan', urlCount: 97 },
  { id: 13, name: '013 BCBS Mississippi', urlCount: 852 },
  { id: 29, name: '029 BCBS Rhode Island', urlCount: 503 },
  { id: 3, name: '003 BCBS Arizona', urlCount: 229 },
  { id: 46, name: '046 BCBS Massachusetts', urlCount: 518 },
  { id: 11, name: '011 BCBS Michigan', urlCount: 1200 },
  { id: 15, name: '015 BCBS North Dakota', urlCount: 623 },
  { id: 42, name: '042 BCBS Alabama', urlCount: 439 },
  { id: 21, name: '021 BCBS Illinois', urlCount: 507 },
  { id: 44, name: '044 BCBS Kansas', urlCount: 835 },
  { id: 10, name: '010 BCBS Kansas City', urlCount: 647 },
  { id: 45, name: '045 BCBS Louisiana', urlCount: 915 },
  { id: 12, name: '012 BCBS Minnesota', urlCount: 202 },
  { id: 22, name: '022 BCBS Montana', urlCount: 507 },
  { id: 14, name: '014 BCBS Nebraska', urlCount: 457 },
  { id: 23, name: '023 BCBS New Mexico', urlCount: 506 },
  { id: 47, name: '047 BCBS North Carolina', urlCount: 483 },
  { id: 24, name: '024 BCBS Oklahoma', urlCount: 507 },
  { id: 25, name: '025 BCBS Texas', urlCount: 507 },
  { id: 30, name: '030 BCBS Vermont', urlCount: 176 },
  { id: 16, name: '016 BCBS Wyoming', urlCount: 363 },
  { id: 31, name: '031 BCBS Idaho', urlCount: 478 },
  { id: 54, name: '054 BCBS California', urlCount: 364 },
  { id: 28, name: '028 BCBS Federal Employees (FEP)', urlCount: 996 },
  { id: 50, name: '050 BCBS South Carolina', urlCount: 708 },
  { id: 51, name: '051 BCBS Tennessee', urlCount: 8 },
  { id: 57, name: '057 CGS Administrators (CMS)', urlCount: 648 },
  { id: 17, name: '017 BCBS Capital', urlCount: 345 },
  { id: 5, name: '005 BCBS CareFirst', urlCount: 559 },
  { id: 63, name: '063 CareSource', urlCount: 358 },
  { id: 33, name: '033 Carelon', urlCount: 88 },
  { id: 106, name: '106 Centene Corporation', urlCount: 1118 },
  { id: 34, name: '034 CMS', urlCount: 355 },
  { id: 55, name: '055 Cigna', urlCount: 470 },
  { id: 64, name: '064 Clover Health', urlCount: 101 },
  { id: 18, name: '018 Community Health Plan WA', urlCount: 176 },
  { id: 65, name: '065 CommunityCare', urlCount: 96 },
  { id: 66, name: '066 Connecticare', urlCount: 60 },
  { id: 67, name: '067 Dean Health Plan', urlCount: 100 },
  { id: 2, name: '002 BCBS Anthem', urlCount: 436 },
  { id: 69, name: '069 EmblemHealth', urlCount: 83 },
  { id: 70, name: '070 EviCore', urlCount: 111 },
  { id: 107, name: '107 Evolent Health', urlCount: 634 },
  { id: 43, name: '043 BCBS Excellus', urlCount: 231 },
  { id: 71, name: '071 Fallon Health', urlCount: 163 },
  { id: 60, name: '060 First Coast (CMS)', urlCount: 229 },
  { id: 6, name: '006 BCBS Florida', urlCount: 728 },
  { id: 72, name: '072 GEHA', urlCount: 30 },
  { id: 73, name: '073 Geisinger Health Plan', urlCount: 309 },
  { id: 74, name: '074 Group Health Cooperative', urlCount: 48 },
  { id: 75, name: '075 BCBS Hawaii (HMSA)', urlCount: 158 },
  { id: 76, name: '076 Health Alliance', urlCount: 107 },
  { id: 77, name: '077 Health New England', urlCount: 124 },
  { id: 78, name: '078 Health Partners Plans', urlCount: 60 },
  { id: 79, name: '079 HealthHelp', urlCount: 175 },
  { id: 80, name: '080 HealthPartners', urlCount: 422 },
  { id: 81, name: '081 Healthfirst', urlCount: 154 },
  { id: 82, name: '082 BCBS Highmark', urlCount: 1436 },
  { id: 83, name: '083 BCBS Horizon', urlCount: 631 },
  { id: 84, name: '084 Humana', urlCount: 242 },
  { id: 85, name: '085 Independence Blue Cross', urlCount: 693 },
  { id: 86, name: '086 Indiana University Health', urlCount: 86 },
  { id: 87, name: '087 Johns Hopkins', urlCount: 36 },
  { id: 88, name: '088 Kaiser Washington', urlCount: 243 },
  { id: 89, name: '089 MVP Health Care', urlCount: 159 },
  { id: 90, name: '090 Mass General Brigham', urlCount: 85 },
  { id: 91, name: '091 Medica', urlCount: 198 },
  { id: 92, name: '092 Medical Mutual Ohio', urlCount: 531 },
  { id: 93, name: '093 MetroPlus', urlCount: 52 },
  { id: 94, name: '094 Moda Health', urlCount: 348 },
  { id: 95, name: '095 Molina Healthcare', urlCount: 168 },
  { id: 96, name: '096 National Govt Services', urlCount: 328 },
  { id: 97, name: '097 Neighborhood Health RI', urlCount: 1413 },
  { id: 98, name: '098 Network Health', urlCount: 24 },
  { id: 99, name: '099 Noridian Healthcare', urlCount: 1060 },
  { id: 100, name: '100 Novitas Solutions', urlCount: 203 },
  { id: 101, name: '101 Oscar Health', urlCount: 306 },
  { id: 102, name: '102 PacificSource', urlCount: 92 },
  { id: 103, name: '103 Palmetto GBA', urlCount: 623 },
  { id: 104, name: '104 Paramount Healthcare', urlCount: 137 },
  { id: 105, name: '105 Point32Health', urlCount: 354 },
  { id: 108, name: '108 Premera Blue Cross', urlCount: 384 },
  { id: 109, name: '109 Presbyterian Health', urlCount: 76 },
  { id: 110, name: '110 Priority Health', urlCount: 125 },
  { id: 111, name: '111 Providence Health', urlCount: 366 },
  { id: 112, name: '112 Regence BlueShield', urlCount: 329 },
  { id: 113, name: '113 Security Health Plan', urlCount: 80 },
  { id: 114, name: '114 SelectHealth', urlCount: 316 },
  { id: 115, name: '115 Sentara Health', urlCount: 413 },
  { id: 116, name: '116 SummaCare', urlCount: 65 },
  { id: 117, name: '117 The Health Plan', urlCount: 22 },
  { id: 118, name: '118 TriCare', urlCount: 2099 },
  { id: 119, name: '119 Triple-S Management', urlCount: 524 },
  { id: 120, name: '120 UCare', urlCount: 50 },
  { id: 121, name: '121 UHA', urlCount: 74 },
  { id: 122, name: '122 UPMC Health Plan', urlCount: 505 },
  { id: 123, name: '123 UnitedHealthcare', urlCount: 252 },
  { id: 124, name: '124 University of Utah Health', urlCount: 76 },
  { id: 125, name: '125 Viva Health', urlCount: 377 },
  { id: 126, name: '126 WPS Government Health', urlCount: 388 },
  { id: 127, name: '127 WPS Health Plan', urlCount: 52 },
  { id: 128, name: '128 WellCare Health Plans', urlCount: 111 },
  { id: 129, name: '129 WellSense Health Plan', urlCount: 918 },
]

// Metadata about the scrape
export const scrapeMetadata = {
  scrapeDate: '2025-08-28',
  scrapeId: 698,
  totalUrls: realUrlCounts.reduce((sum, item) => sum + item.urlCount, 0),
  totalScrapers: realUrlCounts.length,
  activeScrapers: realUrlCounts.filter((s) => s.urlCount > 0).length,
}
